import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { ReaderToolType } from 'constants/ReaderTools';
import { BaseReaderStrategy } from './BaseReaderStrategy';

const Blacklist = [
    ReaderToolType.OpenActivity,
    ReaderToolType.ExportInteractiveObject,
    ReaderToolType.SVG,
    ReaderToolType.Select
];

export const useActiveTeacherStrategy = () => {
    const [{ isActive }] = useStore(StoreTypes.canvas);

    const getReaderToolComponents = useCallback((readerToolComponents) => {
        return BaseReaderStrategy.getFilteredReaderToolComponents(readerToolComponents, Blacklist);
    }, []);

    const isReaderSwipeable = useCallback(() => {
        return !isActive;
    }, [isActive]);

    const isReaderSwitchPageAvailable = useCallback(() => {
        return true;
    }, []);

    return { name: 'ActiveTeacherStrategy', getReaderToolComponents, isReaderSwipeable, isReaderSwitchPageAvailable };
};
